import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import './Landing.css';

const SearchFilterBar = ({ onFilterChange }) => {
  const [searchText, setSearchText] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    onFilterChange(value);
  };

  return (
    <div className="search-filter-container">
      <div className="search-filter-bar">
        <Icon name="search" style={{ marginLeft: '15px', color: '#999' }} />
        <input
          type="text"
          placeholder="Search by club or location..."
          value={searchText}
          onChange={handleChange}
        />
        <button className="filter-button">
          <Icon name="filter" />
        </button>
      </div>
    </div>
  );
};

export default SearchFilterBar;
